import './component.scss'

import LoadMore from '../../../../../resources/scripts/api/loadMore'

export class InterestingList extends LoadMore
{

	constructor(id, params, result)
	{
        super(id, params, result)

		this.id = id
		this.params = params
		this.result = result
        this.$component = document.getElementById(this.id)

        this.init()
	}

	init()
	{
		super.init()
	}

}
